import { render, staticRenderFns } from "./SchoolClassTeam.vue?vue&type=template&id=1250c2c0"
import script from "./SchoolClassTeam.vue?vue&type=script&lang=js"
export * from "./SchoolClassTeam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports